import React from 'react';

const ResumeCard = ({ title, subTitle, result, company_link, des, Backend }) => {
  return (
    <div className="group relative p-6 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md hover:border-cyan-500/30 hover:bg-cyan-500/5 transition-all duration-500">
      {/* Timeline dot */}
      <div className="absolute -left-[41px] top-6 w-4 h-4 rounded-full bg-black border-2 border-cyan-500 group-hover:bg-cyan-500 transition-colors duration-300"></div>

      <div className="flex flex-col gap-3">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
          <h3 className="text-xl font-bold text-white group-hover:text-cyan-300 transition-colors duration-300 font-titleFont">
            {title}
          </h3>
          {result && (
            <span className="text-xs px-3 py-1 rounded-full bg-cyan-500/10 text-cyan-400 border border-cyan-500/20 w-fit">
              {result}
            </span>
          )}
        </div>
        <p className="text-sm text-gray-400">
          {company_link ? (
            <a href={company_link} target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-cyan-300 transition-colors">
              {subTitle}
            </a>
          ) : subTitle}
        </p>
        {des && <p className="text-sm text-gray-400 leading-relaxed mt-1">{des}</p>}
        {Backend && <p className="text-sm text-gray-500 leading-relaxed">{Backend}</p>}
      </div>
    </div>
  );
}

export default ResumeCard
